export default "__VITE_ASSET__DMhgXK4B__"